export default __webpack_public_path__ + "static/media/ironCollab Landingpage.6f5c1d6d.png";